export default __webpack_public_path__ + "static/media/close.ff876a83.svg";